import { render, staticRenderFns } from "./YBLineItem.vue?vue&type=template&id=8cb4523c&scoped=true&"
import script from "./YBLineItem.vue?vue&type=script&lang=js&"
export * from "./YBLineItem.vue?vue&type=script&lang=js&"
import style0 from "./YBLineItem.vue?vue&type=style&index=0&id=8cb4523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb4523c",
  null
  
)

export default component.exports